"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var sidebar_link_1 = __importDefault(require("./sidebar-link"));
var sidebar_link_group_1 = __importDefault(require("./sidebar-link-group"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var tokens_1 = require("../../tokens");
var icon_1 = __importDefault(require("../../atoms/icon"));
var Sidebar = function (props) {
    return React.createElement(Sidebar.Element, __assign({}, automation_attribute_1.default('sidebar'), props));
};
Sidebar.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  float: left;\n  width: 160px;\n  ", " {\n    margin-right: ", ";\n    vertical-align: middle;\n  }\n"], ["\n  float: left;\n  width: 160px;\n  ", " {\n    margin-right: ", ";\n    vertical-align: middle;\n  }\n"])), icon_1.default.Element, tokens_1.spacing.xsmall);
Sidebar.Link = sidebar_link_1.default;
Sidebar.LinkGroup = sidebar_link_group_1.default;
Sidebar.propTypes = {};
Sidebar.defaultProps = {};
exports.default = Sidebar;
var templateObject_1;
//# sourceMappingURL=sidebar.js.map